import React, { useState, useEffect } from 'react';
import './style.scss';

export const StickerPicker = ({ onSelectSticker }) => {
  const [query, setQuery] = useState('sprinkle');
  const [stickers, setStickers] = useState([]);

  useEffect(() => {
    fetch(`https://api.giphy.com/v1/stickers/search?api_key=wEy3b0bZIPxe3BnoYU7nMM5todjFxd38&q=${query}&limit=48`)
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        setStickers(
          res.data.map((s) => {
            return { type: 'image', url: s.images.downsized_medium.url };
          })
        );
      });
    return () => {};
  }, [query]);
  return (
    <div className={'stickerpicker-container'}>
      <input
        className={'searchbar'}
        placeholder={'Search Giphy'}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            setStickers([]);
            setQuery(e.target.value);
          }
        }}
      />

      <div className={'stickers'}>
        {stickers.map((sticker) => (
          <div key={sticker.url} className={'sticker-container'} onClick={onSelectSticker.bind(undefined, sticker)}>
            <img src={sticker.url}></img>{' '}
          </div>
        ))}
      </div>
    </div>
  );
};
